import { createAsyncThunk } from '@reduxjs/toolkit'
import { SpotMatchClearingsType } from '../types'
import { AccountId } from '../../../types'
import {
  getSpotMatchClearings,
  SpotClosedOrdersParams,
} from '../../../api/v1/spot'
import { RootState } from '../../index'
import { uniqBy } from 'lodash'

export const getSpotMatchClearingsAction = createAsyncThunk<
  SpotMatchClearingsType,
  {
    accountId: AccountId
    body: SpotClosedOrdersParams
  },
  {
    state: RootState
  }
>(
  'spot/getSpotMatchClearingsAction',
  async ({ accountId, body }, { getState }) => {
    const r = await getSpotMatchClearings(accountId, body)
    const { results: list, hasMore, nextOffsetId: offsetId } = r.data
    const state = getState()

    return {
      list: body.offsetId
        ? uniqBy([...state.spot.matchClearings.list, ...list], 'id')
        : list,
      isLastPage: !hasMore,
      offsetId,
    }
  },
)
